import { UPDATE_SELECT_ORGANIZATION_DETAILS } from '../../types/organizationTypes';

export const updateSelectOrganizationDetails = (data: any) => {
  return {
    type: UPDATE_SELECT_ORGANIZATION_DETAILS,
    payload: data,
  };
};
